<template>
  <SimpleModuleDashboard
    :module-id="Modules.MENSAJES"
    :profile-id="Profiles.PERSONAL"
    :actions="actions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [{ id: 'inbox', reference: 'inbox', route: 'MessagesStaffInbox', tone: 'primary' }],
  }),
}
</script>
